import { assertExists } from '@blocksuite/global/utils';
import { calcDropTarget, getClosestBlockElementByPoint, getModelByBlockComponent, isInsideDocEditor, matchFlavours, Point, } from '../../_common/utils/index.js';
export class FileDropManager {
    constructor(blockService, fileDropOptions) {
        this.onDragOver = (event) => {
            event.preventDefault();
            // allow only external drag-and-drop files
            const effectAllowed = event.dataTransfer?.effectAllowed ?? 'none';
            if (effectAllowed !== 'all')
                return;
            const { clientX, clientY } = event;
            const point = new Point(clientX, clientY);
            const element = getClosestBlockElementByPoint(point.clone());
            let result = null;
            let rect = null;
            if (element) {
                const model = getModelByBlockComponent(element);
                result = calcDropTarget(point, model, element);
                if (result) {
                    rect = result.rect;
                }
            }
            this._indicator.dropResult = result;
            this._indicator.rect = rect;
        };
        this._onDrop = (event) => {
            const { onDrop } = this._fileDropOptions;
            if (!onDrop)
                return;
            event.preventDefault();
            // allow only external drag-and-drop files
            const effectAllowed = event.dataTransfer?.effectAllowed ?? 'none';
            if (effectAllowed !== 'all')
                return;
            const droppedFiles = event.dataTransfer?.files;
            if (!droppedFiles || !droppedFiles.length)
                return;
            const targetModel = this.targetModel;
            const place = this.type;
            const { clientX, clientY } = event;
            const point = new Point(clientX, clientY);
            onDrop({ files: [...droppedFiles], targetModel, place, point })?.catch(console.error);
            this._indicator.reset();
        };
        this._blockService = blockService;
        this._fileDropOptions = fileDropOptions;
        this._indicator = (document.querySelector('affine-drag-indicator'));
        if (!this._indicator) {
            this._indicator = (document.createElement('affine-drag-indicator'));
            document.body.appendChild(this._indicator);
        }
        if (fileDropOptions.onDrop) {
            this._blockService.disposables.addFromEvent(this._blockService.std.host, 'drop', this._onDrop);
        }
    }
    get editorHost() {
        return this._blockService.std.host;
    }
    get type() {
        return !this._indicator.dropResult ||
            this._indicator.dropResult.type !== 'before'
            ? 'after'
            : 'before';
    }
    get targetModel() {
        const pageBlock = this._blockService.page.root;
        assertExists(pageBlock);
        let targetModel = this._indicator.dropResult?.modelState.model || null;
        if (!targetModel && isInsideDocEditor(this.editorHost)) {
            const lastNote = pageBlock.children[pageBlock.children.length - 1];
            if (!matchFlavours(lastNote, ['affine:note'])) {
                throw new Error('The last block is not a note block.');
            }
            targetModel = lastNote.lastItem();
        }
        return targetModel;
    }
}
//# sourceMappingURL=file-drop-manager.js.map